import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import '@/assets/css/reset.less'
import 'element-plus/dist/index.css'

// use default scrollbar for mac users, scroll.less for others
const userAgent = navigator.userAgent.toLowerCase()
if (userAgent.indexOf('mac') === -1) {
  // require('@/assets/css/scroll.less')
}

const pinia = createPinia()

createApp(App).use(pinia).use(router).mount('#app')
